import { Typography, TypographyProps } from '@mui/material'
import { RhfStyleProps } from '../types/RhfStyleProps';
import { setTextProps, TextProps, setNormalWhiteSpace } from '../types/TextProps';

type Props = RhfStyleProps & TypographyProps & TextProps & {
    component?: any;
    br?: boolean;
}

const Label = ({ sx, className, style, // RhfStyleProps
    text, bold, italic,// TextProps
    component, children, br, variant, ...props }: Props
) => {

    style = setTextProps(style, bold, italic);

    setNormalWhiteSpace(props);

    if (text != null) {
        children = text;
    }

    return (
        <Typography component={(component == null ? (props.paragraph == null ? "span" : "p") : component)}
            sx={sx} className={className} style={style} variant={variant}
            {...props}>
            {children}
            {(br === true ? <br /> : undefined)}
        </Typography >
    )
}

export default Label


//
// 備忘:
// 似乎可以製造類似 ASP.net Literal 元件
// 完整 render 文字表達的 html tag
// React 為了安全性隱藏了此特性，所以暫時不製造 Literal 元件
// 之後如果要動態從資料庫 render html 可以考慮使用 (注意內部文字都要由工程師看過)
//
// Using dangerouslySetInnerHTML in a React application
// https://blog.logrocket.com/using-dangerouslysetinnerhtml-in-a-react-application/
// 用法: <div dangerouslySetInnerHTML={{__html: data}}/>
// 
